"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
var password_1 = require("./utils/password");
var user_1 = require("./utils/user");
/**
 * Create an auth instance with the specific config.
 *
 * @param {object} config configuration object
 * @param {string} config.poolId the Cognito pool ID
 * @param {string} config.clientId the client ID to be used with the specified pool

 * @param {object} config.options
 * {
 *   normalizeUsername: set to true to convert all usernames to lowercase
 * }
 */
exports.default = (function (_a) {
    var poolId = _a.poolId, clientId = _a.clientId, _b = _a.options, options = _b === void 0 ? {} : _b;
    var poolInfo = {
        UserPoolId: poolId,
        ClientId: clientId
    };
    var normalizeUsername = options.normalizeUsername;
    var _isSessionExpired = false;
    var onSessionExpired;
    var isSessionExpired = function () { return _isSessionExpired; };
    /**
     * Set a function to call when a refresh token has expired.
     *
     * @param {function} callback usually a function that unsets any user data and redirects to login
     */
    var setSessionExpirationCallback = function (callback) { return (onSessionExpired = callback); };
    /**
     * Signs up a new user to be registered with the specified credentials.
     *
     * @returns {Promise<CognitoUser>} returns a Promise. Depending on the result, the resolved value will be different:
     *  * **Successful user sign up**: the resolved object will be a `CognitoUser` object with the just-created user (not typically very useful)
     *  * **Failure**: the Promise will reject, and the value will be the Error object from Cognito.
     * @param {string} username usually an email address
     * @param {string} locale, usually 'en', 'es', 'fr' etc
     */
    var createUser = function (username, locale) {
        var userPool = new amazon_cognito_identity_js_1.CognitoUserPool(poolInfo);
        var normalizedUsername = (0, user_1.getNormalizedUsername)(username, normalizeUsername);
        var generatedPassword = (0, password_1.generatePassword)();
        return new Promise(function (resolve, reject) {
            userPool.signUp(normalizedUsername, generatedPassword, [
                new amazon_cognito_identity_js_1.CognitoUserAttribute({ Name: 'locale', Value: locale }),
                new amazon_cognito_identity_js_1.CognitoUserAttribute({ Name: 'email', Value: username })
            ], null, function (err, result) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(result.user);
            });
        });
    };
    /**
     * Trigger the custom login challenge.
     * Invoking this function will send a user email with the verification code.
     *
     * @param {string} username the username (most typically email)
     * @returns {function} returns a callback where the verification code is submitted to. <Return callback(code)>
     */
    var login = function (username) { return __awaiter(void 0, void 0, void 0, function () {
        var normalizedUsername, cognitoUser, verifyCodeCallbackFn;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    normalizedUsername = (0, user_1.getNormalizedUsername)(username, normalizeUsername);
                    cognitoUser = (0, user_1.getCognitoUser)(username, poolInfo, normalizeUsername);
                    cognitoUser.setAuthenticationFlowType('CUSTOM_AUTH');
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            cognitoUser.initiateAuth(new amazon_cognito_identity_js_1.AuthenticationDetails({
                                Username: normalizedUsername
                            }), {
                                onSuccess: function () {
                                    resolve();
                                },
                                onFailure: function (err) {
                                    reject(err);
                                },
                                customChallenge: function (challengeParam) {
                                    cognitoUser['challengeName'] = 'CUSTOM_CHALLENGE';
                                    cognitoUser['challengeParam'] = challengeParam;
                                    resolve(cognitoUser);
                                }
                            });
                        })
                        // This contains the instantiated cognitoUser to ensure the validation code session is valid
                    ];
                case 1:
                    _a.sent();
                    verifyCodeCallbackFn = function (verificationCode) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                        cognitoUser.sendCustomChallengeAnswer(verificationCode, {
                                            onSuccess: function () {
                                                resolve();
                                            },
                                            customChallenge: function () {
                                                var incorrectCodeError = new Error('Incorrect code - please try again.');
                                                incorrectCodeError.code = 'VerificationCodeIncorrect';
                                                reject(incorrectCodeError);
                                            },
                                            onFailure: function (err) {
                                                reject(err);
                                            }
                                        });
                                    })];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); };
                    return [2 /*return*/, verifyCodeCallbackFn];
            }
        });
    }); };
    /**
     * Allows a user to update their cognito locale if they change the language set in the UI
     *
     * @param {string} locale, users preferred language. Ex. "en", "es", "fr", etc.
     * @return {Promise<boolean>} whether the update was successful or not
     */
    var setUserLocale = function (locale) { return __awaiter(void 0, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            user = getUser();
            if (!user) {
                return [2 /*return*/, null];
            }
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    // We must call "getSession" before we can update user attributes
                    // https://github.com/amazon-archives/amazon-cognito-identity-js/issues/275
                    user.getSession(function (err) {
                        if (err) {
                            if (err.code === 'NotAuthorizedException') {
                                _isSessionExpired = true;
                                onSessionExpired && onSessionExpired();
                            }
                            reject(err);
                        }
                        _isSessionExpired = false;
                    });
                    user.updateAttributes([new amazon_cognito_identity_js_1.CognitoUserAttribute({ Name: 'locale', Value: locale })], function (error) {
                        if (error) {
                            reject(error);
                            return;
                        }
                        resolve('Success');
                    });
                })];
        });
    }); };
    /**
     * Checks whether a user exists in the user pool. This currently only works in pools configured in 'Legacy Mode' for user existence errors.
     *
     * @param {string} username (most typically email)
     * @return {Promise<boolean>} whether the user exists or not
     */
    var isExistingUser = function (username) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    // Wrap in a promise so we can wait for the callback results
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var cognitoUser = (0, user_1.getCognitoUser)(username, poolInfo, normalizeUsername);
                            cognitoUser.authenticateUser(new amazon_cognito_identity_js_1.AuthenticationDetails({
                                Username: (0, user_1.getNormalizedUsername)(username, normalizeUsername),
                                Password: null
                            }), {
                                onSuccess: function () {
                                    resolve();
                                },
                                onFailure: function (err) {
                                    reject(err);
                                }
                            });
                        })];
                case 1:
                    // Wrap in a promise so we can wait for the callback results
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    // if the user does not exist then the error will indicate
                    switch (e_1.code) {
                        case 'UserNotConfirmedException':
                        case 'NotAuthorizedException':
                        case 'UsernameExistsException':
                            return [2 /*return*/, true];
                        case 'PasswordResetRequiredException':
                            return [2 /*return*/, true];
                        case 'UserNotFoundException':
                        default:
                            return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Gets the currently logged in user.
     * @returns {CognitoUser} the currently logged-in user, if any
     */
    var getUser = function () {
        var userPool = new amazon_cognito_identity_js_1.CognitoUserPool(poolInfo);
        return userPool.getCurrentUser();
    };
    /**
     * Gets the ID token (a JWT) for the currently logged in user.
     * @returns {Promise<string>} returns a Promise. Depending on the result, the resolved value will be different:
     *  * **Successfully got ID token**: the resolved object will be a string, the JWT ID token
     *  * **Failure**: the Promise will reject, and the value will be an Error object (should be dealt with as 'not logged in')
     */
    var getToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var user = getUser();
                    if (!user) {
                        reject(new Error('User is not logged in'));
                        return;
                    }
                    user.getSession(function (err, session) {
                        if (err) {
                            if (err.code === 'NotAuthorizedException') {
                                _isSessionExpired = true;
                                onSessionExpired && onSessionExpired();
                            }
                            reject(err);
                            return;
                        }
                        if (!(session === null || session === void 0 ? void 0 : session.getIdToken())) {
                            reject(new Error('User id token not found'));
                            return;
                        }
                        _isSessionExpired = false;
                        resolve(session.getIdToken().getJwtToken());
                    });
                })];
        });
    }); };
    /**
     * Logs out the currently logged in user.
     */
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            user = getUser();
            user && user.signOut();
            return [2 /*return*/];
        });
    }); };
    /**
     * Call this before any other auth functions in React Native.
     * amazon-cognito-identity-js expects a storage that is synchronous (localStorage),
     * but React Native uses an asynchronous storage (AsyncStorage). It requires this
     * workaround to get data from AsyncStorage and save it in memory.
     *
     * https://github.com/aws-amplify/amplify-js/blob/amazon-cognito-identity-js%406.3.6/packages/amazon-cognito-identity-js/src/StorageHelper-rn.js#L61
     */
    var syncStorage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var userPool;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userPool = new amazon_cognito_identity_js_1.CognitoUserPool(poolInfo);
                    if (!userPool.storage.sync)
                        return [2 /*return*/];
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            userPool.storage.sync(function (err) {
                                if (err)
                                    reject(err);
                                else
                                    resolve();
                            });
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        createUser: createUser,
        getToken: getToken,
        getUser: getUser,
        isExistingUser: isExistingUser,
        isSessionExpired: isSessionExpired,
        login: login,
        logout: logout,
        setSessionExpirationCallback: setSessionExpirationCallback,
        setUserLocale: setUserLocale,
        syncStorage: syncStorage
    };
});
//# sourceMappingURL=index.js.map